<template>
    <div class="report-pay-code-popup">
        <div class="report-pay-code-top">
            <div class="report-pc-close" @click="clickClose"><span class="icon-close"></span></div>
            <div class="report-pc-title">
                <span class="report-pc-title-icon"></span>
                <div class="report-pc-title-text">
                    <p class="title1">微 信</p>
                    <p class="title2">WECHAT</p>
                </div>
            </div>
            <div class="report-pc-content">
                <qrcode id='qrImg' tag="img" :options="{size: 320, padding: 0}" :value="wechatPayCodeValue" ></qrcode>
                <p class="text">微信扫码支付</p>
            </div>
        </div>
        <div class="report-pay-code-btn-box">
            <button class="report-pay-code-button button1" @click="clickComplete"><div class="text"><span class="icon icon-done"></span>完成</div></button>
            <button class="report-pay-code-button button2" @click="clickAgain"><div class="text"><span class="icon icon-refresh"></span>重试</div></button>
        </div>
        <div class="report-pay-code-btn-text">
            <p>请在微信完成付款，</p>
            <p>支付完成请点『完成』</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportPayCode',
    computed: {
        wechatPayCodeValue() {
            return this.$store.state.pay.wechatPayCodeValue;
        },
        wechatPayParams() {
            return this.$store.state.pay.wechatPayParams;
        }
    },
    methods: {
        clickClose() {
            this.$store.state.pay.reportShowPayCode = false;
        },
        clickComplete() {
            console.log('wechatPayParams---', this.wechatPayParams);
            let bPid = this.wechatPayParams ? this.wechatPayParams.ext : null;
            if(bPid) {
                this.$store.dispatch('user/getUserHomePageData', { id: bPid });
            }
            this.$store.state.pay.reportShowPayCode = false;
        },
        clickAgain() {
            // this.$store.state.pay.reportShowPayCode = false;
            this.$store.dispatch('pay/createPayOrder', {
                params: this.wechatPayParams
            });
        }
    }
}
</script>